import React, { FC, useContext, useEffect, useState } from 'react'

import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Col, Form, Image, Input, Row } from 'antd'
import { MaskedInput } from 'antd-mask-input'
import logo from 'Assets/Images/logo-compulog.svg'
import { InputText, CheckboxItem } from 'Components/Form'
import Loading from 'Components/Loading'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import usuarios from 'Helpers/usuarios'
import { CLAIMS } from 'Hooks/usePermissions/constants.claims'
import { IPerfil, IPermissao, UsuarioAtual } from 'Models/auth'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { authentication } from 'Routes'
import handleToken from 'Services/handleToken'
import AuthService from 'Services/UAA'
import autenticacao from 'Services/WS_DOCAS/autenticacao'
import * as yup from 'yup'

import { FormAuth } from '../styles'

interface IFormInput {
  CPF: string
  Senha: string
  rememberMe: boolean
}

//TODO: ajusta visual do login
const Login: FC = () => {
  const navigate = useNavigate()
  const [ErrorLogin, setErrorLogin] = useState<boolean>(false)
  const [botaoLogin, setBotaoLogin] = useState<any>(React.createRef())
  const [loginResponse, setLoginResponse] = useState<boolean | undefined>()
  const [processandoLogin, setProcessandoLogin] = useState<boolean>(false)
  const [pagina, setPagina] = useState<string>()
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)

  const validationSchema = yup.object().shape({
    CPF: yup.string().required('CPF é Obrigatório'),
    Senha: yup.string().required('Senha é Obrigatório'),
  })

  const hookForm = useForm()

  // useEffect(() => {
  //   if (!window.location.href.includes('localhost')) {
  //     handleToken.cleanToken()
  //     console.log('Token limpo')
  //   }
  // }, [])

  useEffect(() => {
    setProcessandoLogin(true)

    const currentURL: string = window.location.href

    setPagina(currentURL.includes('iranifob') ? '/DocasIraniFob' : '/Docas')

    if (currentURL.includes('at=')) {
      const autorizacao: string = currentURL.split('at=')?.[1]

      if (autorizacao) {
        handleToken.setToken(autorizacao)

        if (
          currentURL.includes('nomeArmazem=') &&
          currentURL.includes('data=')
        ) {
          let cdArmazem: number | undefined

          if (currentURL.includes('cdArmazem=')) {
            const cdArmazemString: string = currentURL.split('cdArmazem=')?.[1]
            cdArmazem = window.parseInt(
              cdArmazemString.substring(0, cdArmazemString.indexOf('&')),
            )
          }

          let nomeArmazem: string = currentURL.split('nomeArmazem=')[1]
          nomeArmazem = nomeArmazem.substring(0, nomeArmazem.indexOf('&'))
          nomeArmazem = nomeArmazem.replaceAll('%20', ' ') //Às vezes o espaço na URL é interpretado como %20

          let dataArmazem: string = currentURL.split('data=')[1]
          dataArmazem = dataArmazem.substring(0, dataArmazem.indexOf('&'))

          alternativeOnSubmit(currentURL, cdArmazem, nomeArmazem, dataArmazem)
        } else {
          alternativeOnSubmit(currentURL)
        }
      }
    } else {
      setProcessandoLogin(false)
    }
  }, [])

  useEffect(() => {
    if (loginResponse !== undefined && pagina) {
      if (loginResponse) {
        navigate(pagina)
      } else {
        setErrorLogin(true)
      }
    }
  }, [loginResponse, navigate])

  const onSubmit = async (values: IFormInput) => {
    setProcessandoLogin(true)

    const { data } = await autenticacao.login(
      values.CPF,
      values.Senha,
      values.rememberMe,
      ID_COMPONENTE.DOCAS,
    )

    if (data?.token) {
      handleToken.setToken(data.token)

      const usuario: UsuarioAtual = {
        perfis: data.autenticacao.perfis,
        cdsTransportadoras: data.cdsTransportadoras,
        cdEntidade: data.autenticacao.entidade.cdEntidade,
        cdEntidadeSistema: data.autenticacao.entidade.cdEntidadeSistema,
        cdUsuario: data.autenticacao.cdUsuario,
        nome: data.autenticacao.nome,
        login: data.autenticacao.login,
        permissoes: verificaPermissoes(data.autenticacao.perfis),
        mestreSistema: data.autenticacao.mestreSistema,
      }

      usuario.cdsTransportadoras =
        usuarios.verificaTransportadorasUsuario(usuario)

      setApplicationContext({
        ...applicationContext,
        usuarioAtual: usuario,
        textoDocumentoViagem:
          data.autenticacao.entidade.cdEntidadeSistema === 299 //Adami
            ? 'Plano de Viagem'
            : 'Documento da Viagem',
      })
    } else {
      setLoginResponse(false)
    }

    setProcessandoLogin(false)
  }

  const alternativeOnSubmit = async (
    currentURL: string,
    cdArmazemPreSelecionado?: number,
    nomeArmazemPreSelecionado?: string,
    dataPreSelecionada?: string,
  ) => {
    try {
      const { data } = await autenticacao.buscaDados(ID_COMPONENTE.DOCAS)

      if (data?.token) {
        let tempoSessaoMs: number | undefined
        let dataInicioSessao: Date | undefined

        if (
          currentURL.includes('tempoSessaoMinutos=') &&
          currentURL.includes('dataInicioSessao=')
        ) {
          let tempoSessao: string = currentURL.split('tempoSessaoMinutos=')[1]
          tempoSessao = tempoSessao.substring(0, tempoSessao.indexOf('&'))
          tempoSessaoMs = window.parseInt(tempoSessao) * 60000 //Conversão para milissegundos

          let inicioSessao: string = currentURL.split('dataInicioSessao=')[1]
          inicioSessao = inicioSessao.substring(0, inicioSessao.indexOf('&'))
          inicioSessao = inicioSessao.replaceAll('%20', ' ') //Às vezes o espaço na URL é interpretado como %20
          dataInicioSessao = new Date(inicioSessao)

          window.sessionStorage.setItem(
            'tempoSessaoMs',
            tempoSessaoMs.toString(),
          )
          window.sessionStorage.setItem('dataInicioSessao', inicioSessao)
        }

        setApplicationContext({
          ...applicationContext,
          usuarioAtual: {
            perfis: data.autenticacao.perfis,
            cdsTransportadoras: data.cdsTransportadoras,
            cdEntidade: data.autenticacao.entidade.cdEntidade,
            cdEntidadeSistema: data.autenticacao.entidade.cdEntidadeSistema,
            cdUsuario: data.autenticacao.cdUsuario,
            nome: data.autenticacao.nome,
            login: data.autenticacao.login,
            permissoes: verificaPermissoes(data.autenticacao.perfis),
            mestreSistema: data.autenticacao.mestreSistema,
          },
          cdArmazemPreSelecionado: cdArmazemPreSelecionado,
          nomeArmazemPreSelecionado: nomeArmazemPreSelecionado,
          dataPreSelecionada: dataPreSelecionada,
          textoDocumentoViagem:
            data.autenticacao.entidade.cdEntidadeSistema === 299 //Adami
              ? 'Plano de Viagem'
              : 'Documento da Viagem',
          tempoSessaoMs: tempoSessaoMs,
          dataInicioSessao: dataInicioSessao,
        })
      } else {
        setLoginResponse(false)
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      console.error(e)
      setProcessandoLogin(false)
    }
  }

  const verificaPermissoes = (perfis: IPerfil[]) => {
    const permissoes: IPermissao[] = perfis[0].permissoes

    for (let iPerfil = 1; iPerfil < perfis.length; iPerfil++) {
      const perfil: IPerfil = perfis[iPerfil]

      for (
        let iPermissao = 0;
        iPermissao < perfil.permissoes.length;
        iPermissao++
      ) {
        const permissaoPerfil: IPermissao = perfil.permissoes[iPermissao]

        if (
          !permissoes.some((permissao) => permissao.id === permissaoPerfil.id)
        ) {
          permissoes.push(permissaoPerfil)
        }
      }
    }

    return permissoes
  }

  useEffect(() => {
    if (applicationContext.usuarioAtual) {
      console.log('applicationContext', applicationContext)

      setLoginResponse(true)
    }
  }, [applicationContext.usuarioAtual])

  document.addEventListener('keyup', function (event) {
    if (event.key === 'Enter') {
      try {
        botaoLogin.click()
      } catch (e) {
        console.log('Login efetuado com sucesso')
      }
    }
  })

  return processandoLogin ? (
    <Loading />
  ) : (
    <Form onFinish={onSubmit} layout="vertical">
      <Row>
        <Col span={24}>
          <Image
            height={60}
            width={220}
            preview={false}
            id="form-login-logo"
            src={logo}
          />
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            name="CPF"
            label={<label style={{ color: 'white' }}>CPF:</label>}
          >
            <MaskedInput mask="111.111.111-11" />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Form.Item
            name="Senha"
            label={<label style={{ color: 'white' }}>Senha:</label>}
          >
            <Input type="password" />
          </Form.Item>
        </Col>
      </Row>

      <Row>
        <Col span={12}>
          <CheckboxItem
            scope="login"
            methods={hookForm}
            name="rememberMe"
            label="Lembrar-me"
            labelColor="white"
          />
        </Col>

        <Col span={12}>
          <Button
            id="form-login-button"
            disabled={hookForm.formState.isSubmitting}
            color="primary"
            type="primary"
            htmlType="submit"
            style={{ width: '100%' }}
            ref={(node) => {
              if (node) {
                setBotaoLogin(node)
              }
            }}
          >
            LOGIN
          </Button>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Button
            type="link"
            onClick={() => navigate(authentication.recoveryPassword)}
            id="form-login-link-esqueceu-senha"
            style={{ marginLeft: '85px' }}
          >
            Esqueceu a senha?
          </Button>
        </Col>
      </Row>
    </Form>
    // <FormAuth name="login" layout="vertical">
    //   <Col>
    //     <Row justify="start">
    //       <Image
    //         height={60}
    //         width={220}
    //         preview={false}
    //         id="form-login-logo"
    //         src={logo}
    //       />
    //     </Row>
    //     <Row>
    //       <InputText
    //         methods={hookForm}
    //         scope="login"
    //         name="CPF"
    //         label="CPF"
    //         type="masked"
    //         mask="111.111.111-11"
    //       />
    //     </Row>

    //     <Row>
    //       <InputText
    //         methods={hookForm}
    //         scope="login"
    //         name="Senha"
    //         label="Senha"
    //         type="password"
    //       />
    //     </Row>
    //     <Row justify="space-between" align="top">
    //       <CheckboxItem
    //         scope="login"
    //         methods={hookForm}
    //         name="rememberMe"
    //         label="Lembrar-me"
    //       />

    //       <Button
    //         id="form-login-button"
    //         disabled={hookForm.formState.isSubmitting}
    //         color="primary"
    //         type="primary"
    //         onClick={hookForm.handleSubmit(onSubmit)}
    //         ref={(node) => {
    //           if (node) {
    //             setBotaoLogin(node)
    //           }
    //         }}
    //       >
    //         LOGIN
    //       </Button>
    //     </Row>

    //     <Row justify="center" align="top">
    //       <Button
    //         type="link"
    //         onClick={() => navigate(authentication.recoveryPassword)}
    //         id="form-login-link-esqueceu-senha"
    //       >
    //         Esqueceu a senha?
    //       </Button>
    //     </Row>
    //   </Col>
    // </FormAuth>
  )
}

export default Login
